<template>
    <v-layout column>
        <v-toolbar color="primary">
            <v-spacer></v-spacer>
                <v-toolbar-title style="color:white;">
                    Solicitação de transferência
                </v-toolbar-title>
                <v-spacer></v-spacer>
        </v-toolbar>
            <v-stepper v-model="step" class="mt-4" style="box-shadow: none;">
                <v-stepper-items style="box-shadow: none;">
                    <v-stepper-content step="1" style="box-shadow: none;" class="ma-0 pa-0">
                        <v-list v-if="solicitacoes && solicitacoes.length > 0">
                            <v-list-tile class="mt-3" avatar v-for="(item, i) in solicitacoes"
                                :key="i" style="height: 120px;"
                            >
                                <v-list-tile-content class="mt-4" style="height: 9em;">
                                    <v-list-tile-title class="mt-3">Nome Fantasia: <b>{{item.posto.nome_fantasia}}</b></v-list-tile-title>
                                    <v-list-tile-sub-title>CNPJ: <b>{{item.posto.cnpj}}</b></v-list-tile-sub-title>
                                    <v-list-tile-sub-title>Data da solicitação: <b>{{item.data_solicitacao | formatDate('DD/MM/YYYY')}}</b></v-list-tile-sub-title>
                                    <v-list-tile-sub-title class="mb-2">Pessoa que solicitou: <b>{{item.representante}}</b></v-list-tile-sub-title>
                                    <v-layout row wrap justify-space-between style="width: 100%;">
                                      <v-btn round small ripple  @click="responderSolicitacao(item.id, false)">
                                        Rejeitar
                                      </v-btn>
                                      <v-spacer></v-spacer>
                                      <v-tooltip left>
                                        <template v-slot:activator="{ on }">
                                          <v-btn v-on="on" round small ripple color="primary" @click="responderSolicitacao(item.id, true)">
                                            Aceitar
                                          </v-btn>
                                        </template>
                                        Ao aceitar esse posto passará lhe pertencer
                                      </v-tooltip>
                                    </v-layout>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
    </v-layout>
</template>

<script>
export default {
  data () {
    return {
      solicitacoes: [],
      step: 1
    }
  },
  methods: {
    responderSolicitacao (id, resposta) {
      this.$store.dispatch('responderSolicitacaoTransferencia', {
        id: id,
        resposta: resposta
      }).then(() => {
        this.carregarSolicitacoes()
        this.$store.dispatch('meusPostos')
      })
    },
    carregarSolicitacoes () {
      this.$store.dispatch('solicitacoesDeTransferencia').then(value => {
        this.solicitacoes = value
      })
    }
  },
  mounted () {
    this.carregarSolicitacoes()
  }
}
</script>
